import React from "react";

import Layout from "../components/extraescolaresLayout";

const Page = () => <Layout />;
export default Page;
